// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedules-area {
  padding-top: 110px;
  padding-bottom: 120px;
  background: #ffffffa5;
}

.section-title {
  margin-bottom: 40px;
}

.evt-tab-inner {
  margin-bottom: 80px;
}

.tab-content-container {
  padding-top: 20px;
}

/* .nav-tabs .nav-item .nav-link {
  background-color: #0080ff;
  color: #fff;
} */

.nav-tabs .nav-item .nav-link.active {
  color: #0080ff;
}

.tab-content {
  border: 1px solid #dee2e6;
  border-top: transparent;
  padding: 15px;
}

.tab-content .tab-pane {
  background-color: #fff;
  color: #d6e2ed;
  min-height: 200px;
  height: auto;
}

@media only screen and (max-width: 767px) {
  .iframe {
    width: 80px;
    margin: 0px;
    padding: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GoodPractices/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".schedules-area {\n  padding-top: 110px;\n  padding-bottom: 120px;\n  background: #ffffffa5;\n}\n\n.section-title {\n  margin-bottom: 40px;\n}\n\n.evt-tab-inner {\n  margin-bottom: 80px;\n}\n\n.tab-content-container {\n  padding-top: 20px;\n}\n\n/* .nav-tabs .nav-item .nav-link {\n  background-color: #0080ff;\n  color: #fff;\n} */\n\n.nav-tabs .nav-item .nav-link.active {\n  color: #0080ff;\n}\n\n.tab-content {\n  border: 1px solid #dee2e6;\n  border-top: transparent;\n  padding: 15px;\n}\n\n.tab-content .tab-pane {\n  background-color: #fff;\n  color: #d6e2ed;\n  min-height: 200px;\n  height: auto;\n}\n\n@media only screen and (max-width: 767px) {\n  .iframe {\n    width: 80px;\n    margin: 0px;\n    padding: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
